/** Refx Servicing configuration name */
export const COMPONENTS_CONFIGURATION_NAME = '@refx/servicing';
